import * as React from 'react';

interface RadarMarkProps {
  size?: number;
}

export function RadarMark({ size = 22 }: RadarMarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="10.5" stroke="var(--color-primary-9)" strokeWidth="1.25" />
      <circle cx="12" cy="12" r="6.5" stroke="var(--color-text-1)" strokeWidth="1.25" opacity="0.85" />
      <circle cx="12" cy="12" r="2" fill="var(--color-primary-9)" />
      <line x1="12" y1="0.5" x2="12" y2="4" stroke="var(--color-primary-9)" strokeWidth="1.25" />
      <line x1="12" y1="20" x2="12" y2="23.5" stroke="var(--color-primary-9)" strokeWidth="1.25" opacity="0.5" />
    </svg>
  );
}
